import React, { Component } from 'react'

export default class AjaxLoader extends Component {
  render() {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        id="svg8"
        version="1.1"
        viewBox="23 20 24 32"
        height="48"
        width="48">
        <defs
          id="defs2" />
        <g
          id="layer1">
          <circle
            r="16"
            cy="36.260414"
            cx="35.07143"
            id="path10"
            style={{ fill: 'orange', strokeWidth: 1.32291667, stroke: 'white' }}><animate attributeName="r" values="8;16;8" dur="2s" repeatCount="indefinite"/></circle>        
        </g>
      </svg>
    )
  }
}
